angular.module('iqxCore')
  .controller('YotiCtrl', function ($scope, $routeParams, ApiSvc, $sce, ApplicationSvc, $window) {
    $scope.uid = $routeParams.uid
    $scope.status = $routeParams.status
    $scope.yotiFrameURL = null
    $scope.IQXNetYotiID = null
    $scope.yotiDone = false

    $scope.createYotiSession = function () {
      return ApiSvc.exec($scope, 'call/NetYotiGetSession', {
        "pUID": $scope.uid,
        "pPersonID": ApplicationSvc.currentUser.personID
      })
        .then(function (procRes) {
          if (procRes.IQXResult.IQXSuccess) {
            $scope.IQXNetYotiID = procRes.IQXResult.IQXSuccess.attrs.id

            return ApiSvc.exec($scope, 'yoti/build', {
              "uid": $scope.uid,
              "baseURL": $window.location.origin
            })
          }
        })
        .then(function (res) {
          if (res.IQXResult.attrs.success === true) {
            $scope.yotiFrameURL = $sce.trustAsResourceUrl(res.IQXResult.data.iFrameURI)

            return ApiSvc.exec($scope, 'call/NetYotiPutSession', {
              "pUID": $scope.uid,
              "pSessionID": res.IQXResult.data.sessionID,
              "pPersonID": ApplicationSvc.currentUser.personID
            })
          }
        })
    }
    switch ($scope.status) {
      case 'success':
        $scope.yotiFrameURL = null
        $scope.yotiDone = true
        return ApiSvc.exec($scope, 'call/NetYotiPutSession', {
          "pUID": $scope.uid,
          "pCandidateCompleted": 1,
          "pPersonID": ApplicationSvc.currentUser.personID
        })
        break;

      case 'create':
      default:
        return $scope.createYotiSession()
        break;
    }
  })
